import React, { Component } from 'react';

import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import stripNonLatin1 from '../../utils/sanitization/stripNonLatin1';

class TextAreaInput extends Component{
  constructor(props){
    super(props);
    this.onTextChange = this.onTextChange.bind(this);
  }


  onTextChange(event){
    const sanitizedValue = stripNonLatin1(event.target.value);
    if(this.props.isForVR){
      this.props.onChange(this.props.parentStateKey, sanitizedValue);
    } else{
      this.props.onChange(sanitizedValue);
    }
  }


  render() {
    const { textType, textName } = this.props;
    return(
      <div>
        <Container>
          <Row>
            <Col>
              {this.props.label}
            </Col>
          </Row>  
          <Row>
            <Col lg="12">
              <Form.Control
                as={textType} 
                name={textName}
                onChange={this.onTextChange}
                value={this.props.content}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


export default TextAreaInput;